// Find an action option by its value
export function findActionByValue(actionOptions, value) {
    if (!Array.isArray(actionOptions)) return undefined;
    return actionOptions.find((r) => r.value === value);
}

// Find a status option by its value
export function findStatusByValue(statusOptions, value) {
    if (!Array.isArray(statusOptions)) return undefined;
    return statusOptions.find((r) => r.value === value);
}

// Clean and normalize the PMX filter object for API requests
export function cleanPMXFilter(filter, pmxDeliveriesRange, pmxDeliveriesSort) {
    const filtered = Object.fromEntries(
        Object.entries(filter)
            .map(([k, v]) => [
                k,
                (['action', 'status'].includes(k) && v && typeof v === 'object')
                    ? v.value ?? v.id ?? ''
                    : v,
            ])
            .filter(([_, v]) => v != null && v !== ''),
    );
    if (pmxDeliveriesRange) filtered.pmxDeliveriesRange = pmxDeliveriesRange;
    if (pmxDeliveriesSort) filtered.pmxDeliveriesSort = pmxDeliveriesSort;
    return filtered;
}